<template>
    <div>
        <div>
            <!-- <div class="divide-y divide-dashed divide-gray-200 border-b border-dashed"> -->
            <template
                v-for="(item, index) in userData"
                :key="index"
            >
                <DataRow
                    v-if="item.dbData"
                    :array-length="userData.length"
                    :data="item"
                    :index="index"
                    @validatePercent="validatePercent"
                    @openPopup="openPopup"
                />
                <SelectRow
                    v-else
                    :array-length="userData.length"
                    :data="item"
                    :index="index"
                    :fundBankList="fundBankList"
                    :autoAddRow="autoAddRow"
                    :groupFundBankList="groupFundBankList"
                    :bankList="bankList"
                    :hasPercent="hasPercent"
                    :hasTitle="hasTitle"
                    @setBankValue="setBankValue"
                    @resetPercent="resetPercent"
                    @setFundCodeAndOptions="setFundCodeAndOptions"
                    @validatePercent="validatePercent"
                    @openPopup="openPopup"
                />
            </template>
        </div>

        <div class="text-right pb-3 md:pt-2 md:pb-5">
            <button
                class="btn text-white btn-sm rounded-full px-5"
                :disabled="userData.length>=20"
                @click="userData.length<=20?addItem():''"
            >
                新增一筆
            </button>
        </div>
    </div>
</template>

<script>
import { ref, computed, inject, watch, toRefs, toRef } from 'vue';
import dialogContnet from '@/json/dialogContent.js';
import { intMinMax } from '@/utils/rules/customRules';

import SelectRow from './SelectRow.vue';
import DataRow from './DataRow.vue';
import _ from 'lodash';

export default {
    components: {
        SelectRow,
        DataRow
    },
    props: {
        hasTitle: {
            type: Boolean,
            default: false,
        },
        bankList: {
            type: Array,
            default: () => [],
        },
        fundBankList: {
            type: Array,
            default: () => [],
        },
        data: {
            type: Array,
            default: () => [],
        },
        dataBase: { // 原始資料
            type: Array,
            default: () => [],
        },
        autoAddRow: { // 是不是無資料時自動增加一列
            type: Boolean,
            default: false,
        },
        hasPercent: { // 是不是需要百分比欄位
            type: Boolean,
            default: true,
        },
        validInput: { // 欄位驗證
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:validInput', 'getValidResult', 'update:subtotal'],
    setup(props, { emit }) {
        const { autoAddRow, validInput } = toRefs(props);
        const $vfm = inject('$vfm');
        const fundList = ref(props.fundBankList);
        const deleteIndex = ref(null);
        const userData = toRef(props, 'data');

        const subtotal = ref(0);
        const obj = {
            fundCode: null,
            percent: 0,
            bankNo: null,
            errorMessage: {}, // errorMessage: { percent: '', bankNo: '', fundCode: '', },
        };
        /** 新增一筆 */
        const addItem = () => {
            userData.value.push(_.cloneDeep(obj));
        };

        /** disabled已選項目 */
        watch(() => props.data, (newValue) => {
            // userData.value = newValue;
            if (newValue.length === 0 && autoAddRow.value) addItem();
            fundList.value.forEach(i => {
                const index = newValue.findIndex(k => k.fundCode === i.fundCode);
                i.disabled = index > -1;
            });
            let count = 0;
            newValue.forEach(i => {
                count += Number(i.percent);
            });
            subtotal.value = isNaN(count) ? '— —' : `${100 - count}`;
            emit('update:subtotal', subtotal.value);
        }, { immediate: true, deep: true });

        /** 基金分類 */
        const groupFundBankList = computed(() => {
            const list = fundList.value.reduce((group, item) => {
                const { bankNo } = item;
                group[bankNo] = group[bankNo] || [];
                group[bankNo].push(item);
                return group;
            }, {});
            return list;
        });

        /** 設定基金欄位與其option */
        const setFundCodeAndOptions = (i) => {
            const item = userData.value[i];
            item.fundCode = null;
            item.percent = 0;
            item.errorMessage.bankNo = '';
        };
        /** 百分比設定為0 */
        const resetPercent = (i) => {
            const item = userData.value[i];
            item.percent = 0;
            item.errorMessage.percent = '';
        };

        /** 選擇基金欄位 並設定對應的銀行欄位 */
        const setBankValue = (i) => {
            const item = userData.value[i];
            const obj = fundList.value.find(k => k.fundCode === item.fundCode);
            item.errorMessage.fundCode = '';
            item.bankNo = obj.bankNo;
            item.errorMessage.bankNo = '';
        };

        /** 驗證百分比 */
        const validatePercent = (i) => {
            const item = userData.value[i];
            const { val, errorMessage } = intMinMax({
                value: item.percent,
                minNum: 5,
                maxNum: item.maxPercent ? item.maxPercent : 100,
            });
            item.errorMessage.percent = errorMessage;
            item.percent = val;
        };

        /** 刪除燈箱：打開 */
        const openPopup = (i) => {
            if (userData.value.length === 1) return;
            modalShow(dialogContnet.remove);
            deleteIndex.value = i;
        };

        /** 燈箱 */
        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        if (params.id === 'remove') {
                            userData.value.splice(deleteIndex.value, 1);
                        }
                        $vfm.hide('DialogBase');
                    },
                    cancel() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };

        /** valid input */
        watch(() => validInput.value, (newVal, oldVal) => {
            if (newVal) {
                let hasError = false;
                let params = null;
                userData.value.forEach(i => {
                    if (!i.dbData && !i.bankNo) {
                        i.errorMessage.bankNo = '請選擇投資標的公司/名稱';
                    }
                    if (!i.fundCode) {
                        i.errorMessage.fundCode = '請選擇投資標的代號/名稱';
                    }
                    if (props.hasPercent && i.percent === 0) {
                        i.errorMessage.percent = '請輸入數值';
                    }
                    const { bankNo, fundCode, percent } = i.errorMessage;
                    if (bankNo || fundCode || percent) {
                        hasError = true;
                    }
                });
                if (!isNaN(parseInt(subtotal.value)) && subtotal.value !== '0') {
                    const str = parseInt(subtotal.value) < 0 ? '分配比例不得大於100%' : '尚有可分配比例未分配';
                    params = {
                        title: '提示',
                        content: `［配置比例］ ${str}`,
                        confirmButton: '確認',
                        cancelButton: null,
                        closeicon: false,
                    };
                } else if (hasError) {
                    params = dialogContnet.validateMsg;
                }
                if (params) {
                    modalShow(params);
                }
                emit('getValidResult', !!params, userData.value);
                emit('update:validInput', false);
            }
        });

        return {
            openPopup,
            validatePercent,
            setFundCodeAndOptions,
            setBankValue,
            resetPercent,
            fundList,
            addItem,
            userData,
            groupFundBankList
        };
    },
};
</script>
